$('document').ready(function(){
  
  	// Setting up the interval, the incrementer and the cutoff time.
    interval = 250;
  	inc      = 0;
    cutoff   = 15000;
  
  	// Are we on a product page?
    if($('#infiniteoptions-container').length) {
        // Setting up an interval.
        theInterval = setInterval(function(){

            // Seeing if infiniteoptions has loaded.
            if(!$('#infiniteoptions-container').is(':empty')) {
                // Adding a class for styling and clearing interval.
                $('#product-header').addClass('infinite-options-enabled')
    			$('#purchase .btn.disable').removeClass('disable').val('Add to Cart')
                clearInterval(theInterval)
            }
            // Clearing interval if it's passed the cutoff time.
            if(inc > cutoff) {
    		  $('#purchase .btn.disable').removeClass('disable').val('Add to Cart')
              clearInterval(theInterval)
            }

            // Incrementing the counter.
            inc += interval

        },interval)
    }
})